
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"46","height":"46"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-938 -341)"}},[_c('circle',{attrs:{"cx":"23","cy":"23","r":"23","transform":"translate(938 341)","fill":"#ecf0f5","opacity":".452"}}),_c('circle',{attrs:{"cx":"18","cy":"18","r":"18","transform":"translate(943 346)","fill":"#ecf0f5"}}),_c('path',{attrs:{"d":"M963.417 369.226l-.569-.564-1.655-1.657-2.217 2.221a1.99 1.99 0 01-2.816-2.811l.568-.567 1.654-1.655-2.219-2.217a1.99 1.99 0 112.813-2.815l.568.564 1.651 1.651 2.219-2.215a1.99 1.99 0 112.811 2.815l-.564.565-1.654 1.651 2.222 2.223a1.988 1.988 0 11-2.812 2.811z","fill":"#8d96a2","stroke":"rgba(0,0,0,0)","stroke-miterlimit":"10"}})])])
          )
        }
      }
    